@let data = trip$ | async; @let flightItineraries = data?.flightItineraries;
@if (isLoading) {
  <booking-loading-page />
} @else {
  @if (flightItineraries?.length && data) {
    @let departureAirportCityName = data?.flightItineraries?.[0]?.departureAirport?.cityName;
    @let departureAt = data?.flightItineraries?.[0]?.departureAt ?? '' | date: 'EEE, MMM d';
    @let returnAt = data?.roundTripDepartureAt ?? '' | date: 'EEE, MMM d';
    @let totalPassengers = data?.totalPassengers;
    @let arrivalAirportCityName = data?.flightItineraries?.[0]?.arrivalAirport?.cityName;
    @let salesAgent = data?.salesAgent; @let tripPortalLink = data?.tripPortalLink;
    @let upsellBanner = tripUpsellBanner$ | async;

    <header></header>

    <div class="trip-page">
      <div class="trip-page-header">
        <div class="d-flex align-items-center trip-page-header-title">
          <ds-button
            (click)="goBack()"
            variant="icon"
            size="s"
            icon="chevronLeft"
            label="Back"
            class="d-md-none"
            data-id="back"
          />
          <ds-button
            (click)="goBack()"
            variant="icon"
            icon="chevronLeft"
            label="Back"
            class="d-none d-md-inline"
            data-id="back"
          />

          <lead-details-title
            [from]="departureAirportCityName"
            [to]="arrivalAirportCityName"
            [type]="data.tripType"
          />

          @if (false) {
            <!--Todo Add logic after back-end changes-->
            <ds-chip [title]="'Itinerary: ' + ''" />
          }
        </div>

        <div class="trip-page-header-subtitle">
          <!--      Todo Add returnAt after backend changes-->
          <lead-details-subtitle
            [departDate]="departureAt"
            [returnDate]="returnAt"
            [travelers]="totalPassengers"
          />
        </div>

        <div class="d-flex align-items-center trip-page-header-actions">
          @if (false) {
            <!--Todo Add logic after back-end changes-->
            <ds-button
              variant="secondary"
              size="s"
              leadingIcon="xmark"
              data-id="cancel"
              (click)="onCancelFlight()"
              label="Cancel flight"
            />
          }
          @if (false) {
            <!--Todo Add logic after back-end changes-->
            <ds-button
              variant="secondary"
              size="s"
              leadingIcon="calendar"
              data-id="change-dates"
              (click)="onChangesDates()"
              label="Change dates"
            />
          }

          <ds-button
            variant="secondary"
            size="s"
            leadingIcon="print"
            data-id="print-itinerary"
            (click)="onPrintItinerary()"
            label="Print itinerary"
          />

          @if (false) {
            <!--Todo Add logic after back-end changes-->
            <ds-button
              variant="secondary"
              size="s"
              leadingIcon="receiptLong"
              data-id="download-receipt"
              (click)="onDownloadReceipt()"
              label="Download receipt"
            />
          }
        </div>
      </div>

      @if (tripPortalLink) {
        <trip-upsell-banner
          class="mx-4 mx-md-0 my-4"
          [emailVariant]="upsellBanner?.emailVariant"
          [timerExpiresAt]="upsellBanner?.timerExpiresAt"
          [tripPortalLink]="tripPortalLink"
        />
      }

      <div class="d-flex flex-column g-8 trip-page-body">
        <div>
          <h2 class="semi-bold trip-page-body-title">Itinerary</h2>

          <portal-option-details
            [itineraries]="data.flightItineraries"
            [portalLink]="data.portalLink"
          />
        </div>

        @let bookings = data.bookings;
        @if (bookings?.length) {
          <div class="d-flex flex-column g-4 trip-page-body-item">
            <div>
              <h2 class="semi-bold mb-1">Bookings</h2>
              <p>Your trips at a glance — manage and view details easily.</p>
            </div>

            @for (booking of bookings; track booking) {
              <a [routerLink]="['/', PortalRoutes.Bookings, booking.portalLink]" class="link">
                @if (booking.bookingHotel) {
                  <booking-hotel-card [data]="booking.bookingHotel" />
                } @else {
                  <booking-trip-card [data]="booking" />
                }
              </a>
            }
          </div>
        }

        <!-- -->
        @if (tripPortalLink) {
          <ds-card
            [routerLink]="['/', PortalRoutes.AncillaryUpsell, tripPortalLink]"
            [queryParams]="{ perpetual: 'true' }"
            class="d-flex flex-column flex-md-row align-items-md-center p-6 mx-4 mx-md-0 cursor-pointer card"
          >
            <img
              [src]="salesAgent?.picture || 'assets/icons/volunteer_activism.svg'"
              alt="agent"
              width="90"
              height="90"
              class="picture"
            />

            <div class="d-flex flex-column mt-2 mt-md-0 ml-md-6">
              <h2 class="semi-bold">Add a gratuity</h2>

              <p class="mt-1">You can add a gratuity to show appreciation for your trip support</p>
            </div>

            <div class="ml-md-auto mt-4 mt-md-0 mb-md-auto">
              <ds-button label="Add Gratuity" />
            </div>
          </ds-card>
        }

        <price-summary
          class="trip-page-body-item"
          [option]="data"
          [disruptionProtection]="disruptionProtection"
          [cancelForAnyReason]="cancelForAnyReason"
          [promocodeDiscountAmount]="data.promocodeAmount"
          [subtitle]="'Total cost of your trip in one view.'"
          [bundle]="bundle"
        />
        @if (false) {
          <!--Add logic after back-end changes-->
          <div>
            <div class="mb-4">
              <h2 class="semi-bold mb-1 trip-page-body-title">Payment details</h2>
              <p>Quick look at your payment method and amount.</p>
            </div>
            <payment-info />
          </div>
        }

        <footer></footer>
      </div>
    </div>
  }
}
